import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { Segment } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const activeTab = state.tabs[ownProps.context]
  return { activeTab }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

class TabContent extends React.Component {
  render() {
    const { activeTab, children, content, open, className } = this.props

    return (
      <Segment
        clearing
        attached={true}
        className={classNames([
          'tab-content',
          className,
          content,
          activeTab === content || (!activeTab && open) ? '' : 'hidden',
        ])}
        children={children}
      />
    )
  }
}

TabContent = connect(mapStateToProps, mapDispatchToProps)(TabContent)
export default TabContent



// WEBPACK FOOTER //
// ./src/components/admin/Helper/TabContent.jsx